const createImportFactory = (path) => () => import (`@/pages/${path}`)
export default [
	{ path: '/home', component: createImportFactory('Home/Home') },
	{ path: '/error', component: createImportFactory('Error/Error') },
	{ path: '/detail/:id', component: createImportFactory('Detail/Detail') },
	{ path: '/success', meta: {title: '预约成功' }, component: createImportFactory('Success/Success') },
	{ path: '/my-order', meta: {title: '我的订单' }, component: createImportFactory('MyOrder/MyOrder') },
  { path: '/', redirect: '/home' }
]



// WEBPACK FOOTER //
// ./src/routes/index.js